/**Session
 * @Auth
 */
export const Session = "/me/";
export const RefreshSession = "/refresh/";
export const Login = "/login/";
export const Logout = "/logout/";
export const ForgotPassword = "/forgot/";
export const ResetPassword = "/reset/";
export const ChangePassword = "/change/";

/**
 * @Competitions
 */
export const Competitions = "/competitions/";
export const CompetitionSchools = "/competition/{competitionId}/schools/";

/**
 * @Reports
 */
export const ReportCompetitions = "/report-competitions/";
export const ReportCompetitionsSubTopic =
  "/competition/{competitionId}/subtopic-report/";
export const ReportSchoolsByCompetition =
  "/competition/{competitionId}/report-schools/";
export const SchoolReportOverall =
  "/competition/{competitionId}/school/{schoolId}/overall-report/";
export const SchoolReportSubTopicWise =
  "/competition/{competitionId}/school/{schoolId}/subtopic-report/";

export const ReportClasses =
  "/competition/{competitionId}/school/{schoolId}/report-classes/";
export const ClassReportOverall =
  "/competition/{competitionId}/class/{classCode}/overall-report/";
export const ClassReportSubTopicWise =
  "/competition/{competitionId}/class/{classCode}/subtopic-report/";

export const ReportStudents =
  "/competition/{competitionId}/class/{classCode}/report-students/";
export const StudentsReportOverall =
  "/competition/{competitionId}/class/{classCode}/student/{studentId}/overall-report/";
export const StudentsReportSubTopicWise =
  "/competition/{competitionId}/class/{classCode}/student/{studentId}/subtopic-report/";

export const SchoolSubtopicOverallReport = "/school/{schoolId}/node/{nodeId}/overall-report/?limit={limit}&offset={offset}";
export const ClassSubtopicOverallReport = "/class/{classId}/node/{nodeId}/overall-report/?limit={limit}&offset={offset}";
export const SchoolSubtopicSkillReport = "/school/{schoolId}/node/{nodeId}/skill-report/?limit={limit}&offset={offset}";
export const ClassSubtopicSkillReport = "/class/{classId}/node/{nodeId}/skill-report/?limit={limit}&offset={offset}";
export const FetchCTQuestion = "/config-type/{ctId}/question/";